import {useNotification} from '@hconnect/uikit/src/common'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useErrorHandler} from 'react-error-boundary'
import {useTranslation} from 'react-i18next'

import {mutations} from '../../../../api/mutations'
import {invalidateSettingsQuery} from '../../../common/providers'
import {ErrorResponse} from '../../../common/types'
import {notifyIfErrorMessage} from '../../../common/utils'

export const useRestoreDepartment = () => {
  const {notify} = useNotification()
  const raiseError = useErrorHandler()
  const {t} = useTranslation()

  return useMutation<
    void,
    AxiosError<ErrorResponse>,
    Parameters<typeof mutations.restoreDepartment>[0]
  >({
    mutationFn: mutations.restoreDepartment,
    onError: (error) => {
      notifyIfErrorMessage(error.response?.data.detail, raiseError, notify)
    },
    onSuccess: () => {
      notify('success', t('success.restoreDepartment'))
      invalidateSettingsQuery('upmRemovedStructure')
      invalidateSettingsQuery('upmStructure')
    }
  })
}
